export enum AddressComponentType {
  Country = 'country',
  State = 'administrative_area_level_1',
  City = 'locality',
  Street = 'route',
  Number = 'street_number',
  ZipCode = 'postal_code',
}
